import React, { useState } from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { space } from "styled-system";
import { ClipCardDescription } from "./../../Components/ClipDescription";
import { ClipRemix } from "./../../Components/ClipRemix";
import { Link } from "../../../Button";
import { Avatar } from "../../../Avatar";
import { Headline } from "../../../Text";
import {
  AvatarBorder,
  getAvatarBorderLevel,
  getAvatarImage,
} from "../../../../Utilities/User";

import { DividerAlt } from "../../../Divider";
import { FollowButton } from "../../../Button";
import { ClipReactions } from "../ClipReactions";
import { canRemix, getDisplayName } from "../../../../Utilities/Clip";
import { Tags } from "../../../../Views/Clip/Tags";
import { getQueryParam } from "../../../../Utilities/QueryParam";
import { EPaywallType } from "../../../Modals/Paywall";
import { useInteractonInterceptor } from "../../../../Hooks/useInteractionInterceptor";
import { trackClipDownload } from "../../../../../utils";
import { useUser } from "../../../../Hooks/useUser";
import { TClipControlsProps } from "../../@types";
import Remix from "../../../../../components/atoms/form/button/remix";
import { ClipOptions } from "../ClipOptions/Index";
import { ClipboardShare } from "../../../Button/Share";
import { CampaignFootnote } from "../../../CampaignFootnote";
import { useRecoilState } from "recoil";
import { AllstarModalState } from "../../../../State/modals";
import { ModalType } from "../../../../@types";

export const ClipControlsSingle = ({
  isFeed,
  clip,
  followUnfollow,
  setPaywallOpen,
  setRemixModalOpen,
  setDownloadModalOpen,
  setShareModalOpen,
  setReportModalOpen,
  setModalOpen,
  setEditModalOpen,
  setFollowModal,
  isProfile,
  isMontage,
  mutateReaction,
}: TClipControlsProps) => {
  const checkFeatureAccessQuery = useInteractonInterceptor();
  const { allstarUser } = useUser();

  const isOwnClip = allstarUser?.user?._id === clip.user._id;
  const ownerId = clip?.user?._id;
  const avatarBorderLevel = getAvatarBorderLevel(clip.user);
  const avatar = getAvatarImage(clip.user);
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const clipLink = !isMontage
    ? `https://${window.location.hostname}/clip?clip=${clip.shareId}`
    : `https://${window.location.hostname}/montage?montage=${clip.shareId}`;
  const to = isMontage
    ? `/montage?montage=${clip.shareId}`
    : `/clip?clip=${clip.shareId}`;
  const displayName = getDisplayName(clip);

  return (
    <>
      <WidthWrapper>
        <StyledContentColumn isFeed={isFeed}>
          <CardContent>
            <Flex
              pb={1}
              justifyContent="space-between"
              alignItems="flex-start"
              flexDirection="column"
            >
              <Flex
                width="100%"
                justifyContent="space-between"
                alignItems={["flex-start", "flex-start", "center"]}
                flexDirection={["column", "column", "row"]}
              >
                <Flex
                  alignItems="center"
                  width="100%"
                  justifyContent="space-between"
                >
                  <Flex width="100%" justifyContent="flex-start">
                    <Flex
                      width="100%"
                      justifyContent="flex-start"
                      flexDirection={"column"}
                    >
                      <ClipRemix
                        views={clip.views}
                        followUnfollow={followUnfollow}
                        clip={clip}
                        height="100%"
                        setFollowModal={setFollowModal}
                        onClick={undefined}
                        classification={undefined}
                        alignment={undefined}
                      />
                      <Flex
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        mt={4}
                        mb={4}
                        flexWrap="wrap"
                        style={{ gap: "20px" }}
                      >
                        <ClipCardDescription
                          to={to}
                          clip={clip}
                          height="100%"
                          onClick={undefined}
                          classification={undefined}
                          truncate={undefined}
                          alignment={undefined}
                          isMontage={isMontage}
                        />

                        <Flex>
                          {canRemix(
                            { ...clip, isMontage },
                            allstarUser?.isAdmin,
                          ) && (
                            <Remix
                              clip={clip}
                              classificiation={undefined}
                              onClick={undefined}
                              setModalOpen={setRemixModalOpen}
                              classification={undefined}
                              isFeed={isFeed}
                              disableOnClick={false}
                            />
                          )}
                        </Flex>
                      </Flex>
                      <Flex
                        justifyContent="space-between"
                        alignContent={"center"}
                        mt={2}
                      >
                        <Owner
                          mr={1}
                          ml={avatarBorderLevel ? 2 : 0}
                          onClick={(e: any) => {
                            e.stopPropagation();
                          }}
                        >
                          {avatarBorderLevel ? (
                            <AvatarBorder type={avatarBorderLevel} size="nav">
                              <Avatar
                                size="nav"
                                image={avatar}
                                to={`/profile?user=${ownerId}`}
                              />
                            </AvatarBorder>
                          ) : (
                            <Avatar
                              size="nav"
                              image={avatar}
                              to={`/profile?user=${ownerId}`}
                            />
                          )}

                          <OwnerLink
                            flex={true}
                            ml={3}
                            mr={1}
                            color="inherit"
                            to={`/profile?user=${ownerId}`}
                            name="clip-username"
                          >
                            <Headline>{displayName}</Headline>
                          </OwnerLink>
                        </Owner>
                        {allstarUser.user?._id !== ownerId && (
                          <StyledFollowButton
                            flex={true}
                            size="tiny"
                            alignSelf="center"
                            userId={ownerId}
                            displayName={displayName}
                            followClassification={"ownerFollow"}
                            followingClassification={"ownerFollowing"}
                            avatar={avatar}
                            followUnfollow={followUnfollow}
                            allstarUser={allstarUser}
                            setFollowModal={setFollowModal}
                          />
                        )}
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </CardContent>
          <DividerAlt width={["100%"]}></DividerAlt>
          <Flex mb={3} justifyContent={["space-between"]}>
            {!isMontage && (
              <StyledClipReactions
                justifyContent="flex-start"
                clipId={clip?._id}
                clip={clip}
                mutateReaction={mutateReaction}
              />
            )}{" "}
            <ClipOptions
              clip={clip}
              clipLink={clipLink}
              isFeed={isFeed}
              classification="round"
              isProfile={isProfile}
              isMontage={isMontage}
              isOwnClip={isOwnClip}
              setDownloadModalOpen={setDownloadModalOpen}
              setShareModalOpen={setShareModalOpen}
              setReportModalOpen={setReportModalOpen}
              setModalOpen={setModalOpen}
              setEditModalOpen={setEditModalOpen}
              onClick={undefined}
              mobileView={false}
              onDownloadClick={async () => {
                const downloadLink = clip.cf?.downloadUrl
                  ? clip.cf?.downloadUrl
                  : `${process.env.REACT_APP_S3_CLIP_BUCKET}/${clip.clipLink}`;
                let data;
                try {
                  data = await checkFeatureAccessQuery({
                    variables: { feature: "FREE_ENGAGED_DOWNLOAD" },
                  });
                } catch (e) {}

                const paywalledUser = data?.data?.checkFeatureAccess;

                if (paywalledUser) {
                  return setAllstarModalState({
                    isOpen: ModalType.Download,
                    data: {
                      type: EPaywallType.download as EPaywallType,
                    },
                    functions: {},
                  });
                }
                const hasMobile = Boolean(
                  clip.mobile?.find(
                    (x: any) =>
                      x.aspectRatio === "9:16" &&
                      ["Processed", "Ready"].includes(x.status),
                  ),
                );
                if (hasMobile) {
                  return setDownloadModalOpen(true);
                }
                trackClipDownload(clip);
                window.open(downloadLink);
              }}
            />
          </Flex>
          <DividerAlt mt={2} />
          <ClipboardShare link={clipLink} clip={clip}></ClipboardShare>
          <DividerAlt />
          <Flex width="100%" flexDirection="column" pb={isMontage ? 3 : 0}>
            {!isMontage && !isFeed && (
              <Tags
                cards={clip.personalizations.cards}
                tags={clip.clipProperties}
                game={clip.game}
                mt={[2, 2, 1]}
                isFeed={true}
              />
            )}
            {isFeed ?? <DividerAlt />}
          </Flex>
        </StyledContentColumn>{" "}
      </WidthWrapper>
    </>
  );
};

const StyledClipReactions = styled(ClipReactions)`
  justify-content: flex-start;
  margin-right: 10px;
  z-index: 2;
`;

const WidthWrapper = styled(Box)`
  width: 380px;
  @media (max-width: 1100px) {
    width: 100%;
  }
`;
const StyledContentColumn = styled<any>(Flex)`
  flex-direction: column;
  height: fit-content;
  padding: 16px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.nedLight};
  z-index: 2;
  box-shadow: 0px 2px 15px ${(props) => props.theme.colors.midnightAlpha50};
  margin-bottom: 10px;
  @media (max-width: 1100px) {
    margin-left: 0px;
    box-shadow: none;
    background-color: transparent;
    padding: 0px;

    width: 905px;
    max-width: 100%;
  }
`;

const CardContent = styled(Box)(space);

const OwnerLink = styled(Link)`
  :hover {
    cursor: pointer;
  }
`;

const Owner = styled(Flex)`
  align-items: center;
  z-index: 1;
  :hover {
    cursor: pointer;
  }
  :hover ${OwnerLink} {
    color: ${(props) => props.theme.colors.envy};
    cursor: pointer;
  }
`;

const StyledFollowButton = styled(FollowButton)`
  height: 40px;
`;
